var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card card-chat-booking",
      class: [
        _vm.message.sender_type === "user" ? "float-right" : "float-left ml-3"
      ]
    },
    [
      _c("div", { staticClass: "card-body" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: { src: _vm.message.imageUrl, alt: "" }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-495c5517", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495c5517","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chatBooking/components/ImageMessage.vue
// module id = 1533
// module chunks = 0